import { useQuery } from '@tanstack/react-query';
import { apiNotification, apiNotificationsList } from 'common/api/srm-api';
import { NOTIFICATIONS_STALE_TIME_MS } from './query.constants';
export const useApiNotificationQuery = (id) => {
    // console.log('useApiNotificationQuery')
    return useQuery({
        queryKey: ['notificationData', id],
        queryFn: () => apiNotification(id),
        enabled: false,
    });
};
export const useApiNotificationsQuery = (params = {}) => {
    var _a;
    const page = (_a = params.page) !== null && _a !== void 0 ? _a : 1;
    return useQuery({
        queryKey: ['notificationsList', page],
        queryFn: () => apiNotificationsList({ page }),
        enabled: true,
        refetchOnMount: 'always',
        staleTime: NOTIFICATIONS_STALE_TIME_MS,
    });
};
